<template>
	<div id="shopcarOne">
		<topheader></topheader>
    	<topsearch></topsearch>
    	<flxedsearch :class="{v_fixed:fixedkey}" v-if="fixedkey"></flxedsearch>
    	<topnav :errlist="navlist"></topnav>
    	<router-view></router-view>
    	 <footerhtml></footerhtml>
    <copyright></copyright>
    <rightflxed></rightflxed>
	</div>
</template>

<script>
	 import topheader from '@/components/topheader'
    import topsearch from '@/components/topsearch'
    import flxedsearch from '@/components/flxedsearch'

     import topnav from '@/components/topnav'
      import footerhtml from '@/components/footer'
    import copyright from '@/components/copyright'
    import rightflxed from '@/components/rightflxed'
	export default {
		 name: 'shopcarOne',
		 components: {
            topheader,
            topsearch,
            flxedsearch,
            footerhtml,
            copyright,
            rightflxed,
            topnav
        },
        data() {
            return {
            	navlist: [],
                fixedkey: false,
            }
        },
         mounted() {

            window.addEventListener('scroll', this.handleScroll)

        },
        methods: {

            handleScroll() {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                console.log()
                if (scrollTop >= 300) {
                    this.fixedkey = true
                } else {
                    this.fixedkey = false

                }
            }
        },

    }
</script>

<style scoped>

</style>
